import React from "react";

type CloseButtonProps = {
    onClick: () => void;
    ariaLabel: string;
};

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, ariaLabel }) => (
    <button
        onClick={onClick}
        style={{
            position: "absolute",
            top: "15px",
            right: "4px",
            color: "red",
            background: "none",
            border: "none",
            fontSize: "36px",
            cursor: "pointer",
            zIndex: 1000,
        }}
        aria-label={ariaLabel}
    >
        ×
    </button>
);

export default CloseButton;
